import React from 'react'
import {connect} from 'react-redux'
import {ActionButton} from '@agillic/agillic-ui'
import {bool, string, func, oneOf, number} from 'prop-types'
import {loginModes, loginModesList} from '../../helpers/login.data'
import {buttonCaption, isButtonDisabled} from '../actionSection.helper'

const {createNewPassword, forgotPassword, normal} = loginModes

const AuthButton = ({isVisible, isProduction, mode, codeSendMessage, isPasswordPolicyPending, passwordPolicy, hasAuthFailed, isAuthInProgress, authFailedTimes, isSecretCodeSending, isFirstTime, auditMessage, onSubmit, username, password, secretCode, confirmPassword, isUsernameDirty}) => (isVisible && (
  <div className='loginButtonWrapper'>
    <ActionButton
      color='darkOrange'
      onClick={onSubmit}
      isDisabled={isButtonDisabled({isUsernameDirty, mode, codeSendMessage, isPasswordPolicyPending, isAuthInProgress, auditMessage, username, password, secretCode, passwordPolicy, confirmPassword})}
      uniqueID={(mode === forgotPassword) ? 'forgotPasswordButton' : 'loginButton'}
    >
      {buttonCaption({
        mode,
        isAuthInProgress,
        isSecretCodeSending,
        isFirstTime,
        hasProductionWarning: isProduction
          && (!hasAuthFailed && authFailedTimes === 0)
          && (mode === normal || (mode === createNewPassword && isFirstTime))
      })}
    </ActionButton>
  </div>
))

const mapStateToProps = ({loginReducer}) => ({
  hasAuthFailed: loginReducer.hasAuthFailed,
  authFailedTimes: loginReducer.authFailedTimes,
  isFirstTime: loginReducer.isFirstTime,
  codeSendMessage: loginReducer.codeSendMessage,
  mode: loginReducer.mode,
  isPasswordPolicyPending: loginReducer.isPasswordPolicyPending,
  isAuthInProgress: loginReducer.isAuthInProgress,
  isSecretCodeSending: loginReducer.isSecretCodeSending,
  auditMessage: loginReducer.auditMessage,
  passwordPolicy: loginReducer.passwordPolicy,
  confirmPassword: loginReducer.confirmPassword,
  isUsernameDirty: loginReducer.isUsernameDirty
})

const mapDispatchToProps = () => ({})

AuthButton.propTypes = {
  isVisible: bool,
  isProduction: bool,
  hasAuthFailed: bool,
  authFailedTimes: number,
  isFirstTime: bool,
  codeSendMessage: string,
  mode: oneOf(loginModesList),
  isPasswordPolicyPending: bool,
  isAuthInProgress: bool,
  isSecretCodeSending: bool,
  onSubmit: func.isRequired,
  password: string,
  confirmPassword: string
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthButton)
